/** Persisted when the user turns off “Dim background”. */
export const CONVERSION_POPUP_NO_DIM_OVERLAY = 'rgba(0,0,0,0)';

export function isConversionPopupDimEnabled(customOverlay: string | undefined): boolean {
  return customOverlay !== CONVERSION_POPUP_NO_DIM_OVERLAY;
}

/**
 * Resolves backdrop overlay for conversion popups.
 * - Explicit transparent token → no dim
 * - Custom color → use as-is
 * - Otherwise → theme default, then legacy fallback
 */
export function resolveConversionPopupOverlay(
  customOverlay: string | undefined,
  themeOverlay: string | undefined
): string {
  if (customOverlay === CONVERSION_POPUP_NO_DIM_OVERLAY) {
    return CONVERSION_POPUP_NO_DIM_OVERLAY;
  }
  if (customOverlay?.trim()) {
    return customOverlay.trim();
  }
  if (themeOverlay?.trim()) {
    return themeOverlay.trim();
  }
  return 'rgba(0,0,0,0.55)';
}
